import moment from "moment";

export const parseTimestamp = (timestamp, format = '') => {
	if (!timestamp) return

	const date = timestamp.seconds
		? new Date(timestamp.seconds * 1000)
		: timestamp

	if (format === 'HH:mm') {
		return moment(date).format(format)
	} 
	else if (format === 'hh:mm A') {
		return moment(date).format('h:mm A')
	} 
	else if (format === 'DD MMMM YYYY') {
		const options = { month: 'long', year: 'numeric', day: 'numeric' }
		return `${new Intl.DateTimeFormat('en-GB', options).format(date)}`
	} 
	else if (format === 'DD/MM/YY') {
		const options = { month: 'numeric', year: 'numeric', day: 'numeric' }
		return `${new Intl.DateTimeFormat('en-GB', options).format(date)}`
	} else if (format === 'DD MMMM, HH:mm') {
		const options = { month: 'long', day: 'numeric' }
		return `${new Intl.DateTimeFormat('en-GB', options).format(
			date
		)}, ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
	}
	else if (format === 'DD MMM, YYYY' || format === 'MMM DD, YYYY' || format === 'YYYY, MMM DD') {
		return moment(date).format(format)
	}

	return date
}


export const isSameDay = (d1, d2) => {
	return (
		d1.getFullYear() === d2.getFullYear() &&
		d1.getMonth() === d2.getMonth() &&
		d1.getDate() === d2.getDate()
	)
}

export const getWeekDaysFromDateRange = (startDate, endDate) => {
	let weekDays = []
	const diff = moment(endDate).diff(moment(startDate).toDate(), 'days') + 1
	const lessThenWeek = diff < 7
	if (lessThenWeek) {
		for (let m = moment(startDate); m.diff(endDate, 'days') <= 0; m.add(1, 'days')) {
			weekDays.push(m.format('dddd'))
		}
	}
	else {
		weekDays = moment.weekdays()
	}
	return weekDays
}